<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

const { locale } = useI18n()

locale.value = 'cn'
</script>

<template>
  <RouterView />
</template>

<style lang="scss">
#app {
  font-family: 'Inter', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  margin: 0;
  min-width: 20rem;
}
</style>
